import { useQueryClient } from '@tanstack/react-query';
import { useLocalizationContext } from 'shared/lib/localization';
import { NothingToDisplay } from 'shared/ui/nothing-to-display';

export const NoLegalDocuments = () => {
    const queryClient = useQueryClient();
    const {
        localizationService: { get },
        language,
    } = useLocalizationContext();

    return (
        <NothingToDisplay
            buttonText={get('Licenses.NoAgreementsData.ButtonText')}
            description={get('Licenses.NoAgreementsData.Description')}
            title={get('Licenses.NoAgreementsData.Header')}
            onReload={() =>
                void queryClient.invalidateQueries({ queryKey: ['legal-documents', language] })
            }
        />
    );
};
